import React, { useEffect } from 'react';
import { getCurrentUser} from 'aws-amplify/auth';
import { getUser } from '../../api/graphql';
import { useMapContext } from '../../contexts/MapContext';
import LIDSummary from './LIDSummary';
import AddLIDPanel from './AddLIDPanel';
import RunModel from './RunModel';
import { useLIDContext } from '../../contexts/LIDContext';

const LIDPanel = ({userData: initialUserData}) => {

    const {
        userData, 
        setUserData,
        devPlanID,
        setDevPlanID,
        LIDMode,
        setLIDMode,
        colorScheme,
        selectedFeature,
        mapClickInfo,
        selectedStormOption,
        setInpFile,
        planIsRunning,
        outFileExists,
        addGIFromBrush,
      enableLIDpanel,
      setMouseDown,
      pendingOperations,
    } = useMapContext();

    const {
        devPlanContent,
    } = useLIDContext();

    const selectedFeatureData = selectedFeature.Data;
    const selectedLayer = mapClickInfo.selectedLayer;


    useEffect(() => {
        if (LIDMode) {
            console.log("We turned LIDMode on");
            if (userData && userData.id) {
                if (userData.developmentPlans?.items) {
                    console.log("This is what we found in userData.developmentPlans: ", userData.developmentPlans.items);
                    if (userData.developmentPlans.items.length > 0) {
                        console.log("The devPlanID is: ", devPlanID);
                        if (devPlanID === '') {
                            setDevPlanID(userData.developmentPlans.items[0].id);
                        }
                    }
                } else {
                    console.log("We don't have any development plans yet");
                }
            } else {
                console.log("we don't have userData yet, so we're fetching it");
                fetchUserData();
            }
        }
    }, [LIDMode, userData]);

    useEffect(() => {
        if (selectedStormOption && userData?.id && devPlanID) {
            const selectedPlan = userData.developmentPlans?.items?.find(plan => plan.id === devPlanID);
            if (selectedPlan) {
                setInpFile(`GLWA_${selectedStormOption}_${userData.id}_${devPlanID}.inp`);
                console.log("The inpFile is now: ", `GLWA_${selectedStormOption}_${userData.id}_${devPlanID}.inp`);
            }
        }
    }, [selectedStormOption, userData, devPlanID]);

    useEffect(() => {
        const selectedPlan = userData?.developmentPlans?.items?.find(plan => plan.id === devPlanID);
        if (selectedPlan) {
            console.log("The devPlanID is now: ", selectedPlan.name);
        } 
    }, [devPlanID, userData]);

    const fetchUserData = async () => {
        try {
            const { username: userId } = await getCurrentUser();

            const userDataResponse = await getUser(userId);
            setUserData(userDataResponse.getUser);
            console.log("Reran fetchUserData: ", userDataResponse.getUser);
        } catch (error) {
            console.error('Error fetching user data:', error);
        }
    };

    // This useEffect ensure the AddLIDPanel (GI) will show up again
    useEffect(() => {
        if ((colorScheme === "standard") && selectedFeatureData && (selectedLayer === 'subcatchment') ){
            setLIDMode(true);
        }
    }, [selectedFeatureData, selectedLayer])

    return (
        <div onMouseEnter={() => setMouseDown(false)}>
            {pendingOperations === 0 && (outFileExists || planIsRunning) && devPlanContent && Object.keys(devPlanContent).length > 0 && (
                <LIDSummary />
            )}
            

            {pendingOperations === 0 && !outFileExists && !planIsRunning && enableLIDpanel && (
                (addGIFromBrush || (selectedFeatureData && selectedLayer === 'subcatchment')) && (
                    <AddLIDPanel />
                )
            )}

            {pendingOperations === 0 && <RunModel />}

        </div>
    );
};

export default LIDPanel;

